import { Link } from 'react-router-dom';
import { siteInfo, navLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="container-wide py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <h3 className="text-lg font-bold font-heading text-background-50 mb-4">
              {siteInfo.name}
            </h3>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-background-200 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-background-200 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-background-200 hover:text-background-50 transition-colors" aria-label="小红书">
                <i className="ri-red-packet-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-background-50 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-background-50 mb-4">热门线路</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/article/sunset-romance-3day" className="text-sm text-background-300 hover:text-primary-400 transition-colors">日落浪漫·三日精华游</Link></li>
              <li><Link to="/article/island-romance-5day" className="text-sm text-background-300 hover:text-primary-400 transition-colors">海岛浪漫·五日深度体验</Link></li>
              <li><Link to="/article/lifetime-proposal-4day" className="text-sm text-background-300 hover:text-primary-400 transition-colors">一生一世·求婚定制之旅</Link></li>
              <li><Link to="/article/free-spirit-7day" className="text-sm text-background-300 hover:text-primary-400 transition-colors">随心所欲·七日自由行</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-background-50 mb-4">联系我们</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-background-300">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-xs"></i>
                </span>
                <a href="tel:4008886688" className="hover:text-primary-400 transition-colors">{siteInfo.phone}</a>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </span>
                <a href={`mailto:${siteInfo.email}`} className="hover:text-primary-400 transition-colors">{siteInfo.email}</a>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-300">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-xs"></i>
                </span>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 让每段旅程都成为难忘的爱情故事
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}